var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M12.3 9.8l1.8 3 1.9-3h2.3l-3 4.5 3.3 4.9h-2.5L14 15.9l-2.1 3.3H9.6l3.3-4.9-2.5-3.7H8.1v3.7H6V4.9h5.1c.4 0 .8.1 1.1.2.3.1.6.3.9.6.2.2.4.5.6.8.1.3.2.6.2 1 0 .6-.1 1-.3 1.4-.3.3-.7.7-1.3.9zM12 24c6.6 0 12-5.4 12-12S18.6 0 12 0 0 5.4 0 12s5.4 12 12 12zM10.3 9.1c.5 0 .8-.1 1.1-.3.2-.2.4-.6.4-1 0-.5-.1-.8-.4-1-.2-.2-.6-.3-1.1-.3H8v2.7h2.3z" })
  );
});


// WEBPACK FOOTER //
// ./src/static/images/rx.svg